import { isEqual } from 'radash';
import { proxy, subscribe } from 'valtio';

import { ComponentQuery, SortType } from 'models';
import { deepClone } from 'helpers/deep-clone';

import { SearchService } from 'components/component-overview/services/SearchService';
import { componentSearchData } from 'components/component-overview/state/component-search-data';
import { CONVERTER_CATEGORIES, getConverterCategory } from 'components/dc-microgrids/sections/converter-categories';

import { componentSearchWeights } from './component-search-weights';

export const DEFAULT_SEARCH_COMPONENT_FILTERS: ComponentQuery = {
    query: '',
    search: '',
    type: undefined,
    catalog: undefined,
    manufacturer: '',
    distributor: undefined,
    ports: [],
    excludePorts: undefined,
    maxPorts: undefined,
    charging: undefined,
    includeArchived: false,
    energyCapacity: undefined,
    ratings: undefined,
    batteryTechnologies: undefined,
    solarTechnologies: undefined,
    breakerType: undefined,
    openingTime: undefined,
    fusePoles: undefined,
    fuseMinBreakingCapacity: undefined,
    breakerMinBreakingCapacity: undefined,
    sort: SortType.RELEVANCE,
    aiEnabled: false,
    inAppSupport: undefined,
    regionAvailability: undefined,
    compliances: undefined,
    priorityManufacturer: undefined,
    productsForCompatibility: undefined,
    application: undefined,
    maxPrice: undefined,
    hasPrice: undefined,
    hasLeadTime: undefined,
    hasCompatibleWith: undefined,
    cable: {
        voltageType: 'DC',
    },
};

const componentSearchFilters = proxy<ComponentQuery>(deepClone(DEFAULT_SEARCH_COMPONENT_FILTERS));

const clearStaleCategoryFilters = () => {
    const { ports, maxPorts, excludePorts } = componentSearchFilters;
    if (!maxPorts && !excludePorts?.length) return;

    const category = getConverterCategory(ports, maxPorts);
    const preset = CONVERTER_CATEGORIES.find((preset) => preset.value === category);

    if (maxPorts && maxPorts !== preset?.maxPorts) {
        SearchService.setFilter('maxPorts', undefined);
    }

    if (excludePorts?.length && !isEqual(excludePorts, preset?.excludePorts)) {
        SearchService.setFilter('excludePorts', undefined);
    }
};

const clearStaleBreakerType = () => {
    const { type, breakerType } = componentSearchFilters;
    if (!breakerType?.length || type === 'breaker') return;

    SearchService.setFilter('breakerType', undefined);
};

const searchAgainIfChanges = (changes: unknown[]) => {
    if (changes.length) {
        componentSearchData.page = 0;
        SearchService.debouncedSearch();
    }
};

subscribe(componentSearchFilters, clearStaleCategoryFilters);
subscribe(componentSearchFilters, clearStaleBreakerType);
subscribe(componentSearchFilters, searchAgainIfChanges);
subscribe(componentSearchWeights, searchAgainIfChanges);

export { componentSearchFilters };
